import { Form, Formik } from "formik";
import Button from "../../../shared/ui/Button";
import FormikLabeledInput from "../../../shared/ui/Form/FormikLabeledInput";
import { FormRadioGroup } from "../../../shared/ui/Form/FormRadioGroup";
import LabeledFormikSelect from "../../../shared/ui/Form/LabeledFormikSelect";
import { CommuneInvestmentSchema } from "../../../shared/ui/Form/schema";

const CommuneInvestmentForm = ({ onSuccess }) => {
    const initialValues = {
        llpName: "",
        paymentCollection: "DIRECT_PAYMENT",
        bankAccountName: "",
        bankAccountNumber: "",
        bankAccountType: "Current",
        razorpayTransferAccount: "",
    };

    const paymentOptions = [
        {
            value: "DIRECT_PAYMENT",
            label: "Direct Payment",
            subLabel: "Cheque Payment",
        },
        {
            value: "PAYMENT_GATEWAY",
            label: "Payment Gateway",
            subLabel: "Razorpay PG",
        },
    ];

    const handleSubmit = (values) => {
        onSuccess(values);
    };

    return (
        <div className="p-4 xs:pb-2 overflow-y-scroll font-vietnam bg-white">
            <Formik
                initialValues={initialValues}
                validationSchema={CommuneInvestmentSchema}
                onSubmit={handleSubmit}
            >
                {({ values, setFieldValue }) => (
                    <Form className="space-y-2">
                        <FormikLabeledInput
                            label="LLP Name"
                            name="llpName"
                            required
                        />

                        <FormRadioGroup
                            name="paymentCollection"
                            label="Payment Collection"
                            wrapperClass="flex-col"
                            optionContainerClass="gap-2 md:gap-5"
                            options={paymentOptions.map((opt) => ({
                                value: opt.value,
                                label: opt.label,
                                subLabel: opt.subLabel,
                            }))}
                        />

                        <FormikLabeledInput
                            label="Bank Account Name"
                            name="bankAccountName"
                            required={
                                values.paymentCollection === "PAYMENT_GATEWAY"
                            }
                        />

                        <FormikLabeledInput
                            label="Bank Account Number"
                            name="bankAccountNumber"
                            required
                        />

                        <LabeledFormikSelect
                            label="Bank Account Type"
                            name="bankAccountType"
                            options={[
                                {
                                    label: "Current Account",
                                    value: "Current",
                                },
                                {
                                    label: "Savings Account",
                                    value: "Savings",
                                },
                            ]}
                            required
                        />
                        {values.paymentCollection === "PAYMENT_GATEWAY" && (
                            <FormikLabeledInput
                                label="Razorpay Transfer Account"
                                name="razorpayTransferAccount"
                                required={
                                    values.paymentCollection ===
                                    "PAYMENT_GATEWAY"
                                }
                            />
                        )}

                        <Button type="submit" className="w-full">
                            Submit LLP Details
                        </Button>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default CommuneInvestmentForm;
